(ns app.front.view.complaint.detail-view
  (:require [app.domain.complaint.model :as complaint-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.file.download :as file-download]
            [app.front.ui.modal :as ui-modal]
            [app.front.util :as futil]
            [app.front.view.complaint.add-form :as complaint-form]
            [app.front.view.complaint.new-case-view :as new-case-view]
            [app.front.view.complaint.subs :as complaint-subs]
            [app.front.view.complaint.util :as complaint-util]
            [app.front.view.property.util :as property-util]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [potpuri.core :as p]))


(defn form-row [key val & [class]]
  [:div.flex-1
   (when class {:class class})
   [:div.font-bold.text-sm.mt-4 key]
   [:div.mt-1.mb-2 val]])

(defn- complaint-source-label
  [{:complaint/keys [external-source source]} tr lang]
  (or (some-> source vector tr)
      (some-> external-source (complaint-model/complaint-source-label lang))))

(defn complaint-content [{:keys [complaint tr lang loading? modal?]}]
  (let [{:complaint/keys [category-group-config description description-of-location response-requested?
                          complainer-name complainer-address complainer-email complainer-phone severity] :as complaint} complaint
        property                                                                                                        (:complaint/property complaint)
        photos                                                                                                          (complaint-model/complaint-photos complaint)
        location                                                                                                        (:entity/location complaint)
        address                                                                                                         (or (-> property :property/primary-address :address/full-address)
                                                                                                                            (:complaint/address complaint)
                                                                                                                            (get-in location [:address :address/full-address])
                                                                                                                            (let [{:keys [longitude latitude]} (futil/lat-long location)]
                                                                                                                              [:div
                                                                                                                               [:p (tr [:location/latitude]) ": " latitude]
                                                                                                                               [:p (tr [:location/longitude]) ": " longitude]
                                                                                                                               [:p (:location/description location)]]))
        source-label                                                                                                    (complaint-source-label complaint tr lang)]
    (if loading?
      [:div
       (cc/inline-loading {:description (tr [:code-enforcement/loading-complaint])})]
      [:div.px-1
       [:h4 address]
       (when (and (or property location) (not (:hide-property-link complaint)))
         [:div.mt-1
          [:a {:on-click   #(>evt [::complaint-subs/hide-complaint-modal])
               :href       (property-util/property-link property (p/assoc-if {:complaint-ref (:complaint/id complaint)}
                                                                             :modal modal?))
               :class-name "no-underline hover:underline text-ui-blue"}
           (tr [:complaint/link-to-property])]
          [form-row (tr [:domain/state]) (tr [(:domain/state complaint)])]
          [form-row (tr [:entity/created]) ((<sub [::date-util/date-time-fn]) (:entity/created complaint))]
          [form-row (tr [:complaint/category]) (config-model/localized-name category-group-config lang)]
          [form-row (tr [:complaint/description]) description]
          (when description-of-location
            [form-row (tr [:complaint/description-of-location]) description-of-location])
          (when severity
            [form-row (tr [:complaint/severity]) (tr [severity])])
          (when (not-empty photos)
            [form-row (tr [:complaint/photos])
             [:div
              (futil/for-frag [photo photos]
                [:img {:src (file-download/download-href :file/download-complaint-photo
                                                         {"file-id" (:db/id photo)
                                                          "preview" true})}])]])
          (when complainer-name
            [:div.mt-4.p-4.border-solid.border-2.border-ui-gray.rounded-md.bg-white
             [:h3.mb-2 (tr [:complaint/complainer-information])]
             [:div.flex.flex-wrap
              [form-row (tr [:complaint/name]) complainer-name "m-4"]
              [form-row (tr [:complaint/address]) complainer-address "m-4"]
              [form-row (tr [:complaint/email]) complainer-email "m-4"]
              [form-row (tr [:complaint/phone]) complainer-phone "m-4"]]])
          [:div.flex
           (when source-label [form-row (tr [:complaint/source]) source-label])
           [form-row (tr [:complaint/response-requested?]) (if response-requested? (tr [:yes]) (tr [:no]))]]])])))

(defn complaint-reply-link [tr name email address]
  (str "mailto:" (js/encodeURIComponent name)
       "<" email ">"
       "?subject="
       (->> [address]
            (tr [:complaint/response-email-subject])
            js/encodeURIComponent)))

(defn complaint-modal-view [{:keys [tr allow-edit? action-events] :as params}]
  (let [complaint-id            (<sub [::complaint-subs/selected-complaint])
        complaint               (<sub [::entities/entity {:complaint/id complaint-id}])
        permit-type             (complaint-model/complaint-permit-type complaint)
        complaint-address       (-> complaint
                                    :complaint/property
                                    :property/primary-address
                                    :address/full-address)
        complaint-photo-ids     (<sub [::complaint-subs/complaint-photo-ids (:db/id complaint)])
        edit-permission?        (complaint-util/can-edit-complaint? complaint)
        state-open?             (du/in-state? :complaint.state/open complaint)
        on-close                (fn [_]
                                  (>evt [::complaint-subs/hide-complaint-modal])
                                  (when-let [cleanup-event (:cleanup-event action-events)]
                                    (>evt cleanup-event))
                                  false)
        open?                   (boolean complaint-id)
        edit?                   (boolean (<sub [::complaint-subs/complaint-data-edit]))
        reopen?                 (boolean (<sub [::complaint-subs/complaint-reopen]))
        modal-loading?          (<sub [::complaint-subs/modal-loading?])
        modal-saving?           (<sub [::complaint-subs/modal-saving?])
        cat-missing-or-removed? (not (some->> (:complaint/category-group-config complaint)
                                              (du/in-state? :group-config.state/enabled)))
        tr                      (if permit-type
                                  (<sub [::complaint-subs/complaint-tr permit-type])
                                  tr)]
    [ui-modal/composed-input-modal
     {:open                   open?
      :selector-primary-focus "button.bx--modal-close"
      :class-name             "text-left"
      :on-close               on-close}
     (cc/modal-header {:close-modal on-close})
     (cc/modal-body
       {:class-name "mt-4"}
       (when complaint-id
         (if (or modal-loading? modal-saving?)
           [:div
            (cc/inline-loading {:description (tr [(if modal-loading?
                                                    :code-enforcement/loading-complaint
                                                    :code-enforcement/saving-complaint)])})]
           [:div.flex-grow.overflow-y-auto.pb-2
            (if reopen?
              [complaint-form/category-selection-for-reopen
               (util/mmap {:authority-groups (->> (<sub [::complaint-subs/selected-group])
                                                  :authority-groups
                                                  (filter #(-> complaint
                                                               :domain/authority-group
                                                               :db/id
                                                               (= (:authority-group-id %)))))
                           :finalize-reopen  #(do (>evt [::complaint-subs/set-complaint-reopen false])
                                                  (>evt [::complaint-subs/update-complaint
                                                         (:complaint/id complaint)
                                                         {:domain/state                    :complaint.state/open
                                                          :complaint/category-group-config (:db/id %)}
                                                         (complaint-subs/mutation-options action-events)])
                                                  (>evt [::complaint-subs/hide-complaint-modal]))
                           :lang             (<sub [:language])} tr)]
              (if edit?
                [complaint-form/form-content
                 (util/mmap {:authority-groups             (->> (<sub [::complaint-subs/selected-group])
                                                                :authority-groups
                                                                (filter #(-> complaint
                                                                             :domain/authority-group
                                                                             :db/id
                                                                             (= (:authority-group-id %)))))
                             :complaint-data               (<sub [::complaint-subs/complaint-data-edit])
                             :on-change-evt-immediate-save ::complaint-subs/set-existing-complaint-data
                             :on-change-evt-delayed-save   ::complaint-subs/set-existing-complaint-data-debounce
                             :change-event-options         (when-let [refresh-event (:refresh-event action-events)]
                                                             {:refresh-event refresh-event})
                             :field-prefix                 (:complaint/id complaint)
                             :source-selectable?           (complaint-model/source-change-allowed? complaint)
                             :address                      complaint-address
                             :form-mode                    :complaint/edit
                             :lang                         (<sub [:language])} tr)]
                [complaint-content (assoc params
                                          :complaint complaint
                                          :edit? edit?
                                          :modal? true)]))
            (let [can-create-case? (and allow-edit? edit-permission? (not edit?) (not reopen?))]
              [:div.mt-6
               (when can-create-case?
                 [:<>
                  [:span
                   (when ((du/in-state-fn :complaint.state/open :complaint.state/abandoned) complaint)
                     (cc/button {:size     :small
                                 :kind     :tertiary
                                 :on-click #(if (and cat-missing-or-removed? (not state-open?))
                                              (>evt [::complaint-subs/set-complaint-reopen true])
                                              (do
                                                (>evt [::complaint-subs/update-complaint
                                                       (:complaint/id complaint)
                                                       {:domain/state (if state-open?
                                                                        :complaint.state/abandoned
                                                                        :complaint.state/open)}
                                                       (complaint-subs/mutation-options action-events)])
                                                (>evt [::complaint-subs/hide-complaint-modal])))}
                                (tr [(if state-open?
                                       :code-enforcement/abandon-complaint
                                       :code-enforcement/reopen-complaint)])))]
                  [:span
                   (when state-open?
                     (cc/button
                       {:size       :small
                        :class-name "ml-4"
                        :on-click   #(do
                                       (>evt [::new-case-view/save-complaint-for-case-creation complaint])
                                       (>evt [::complaint-subs/set-permit-type-for-case-creation permit-type])
                                       (>evt [::new-case-view/select-all-complaint-photos complaint-photo-ids])
                                       (>evt [::new-case-view/open-create-modal (:cleanup-event action-events)])
                                       (>evt [::complaint-subs/hide-complaint-modal]))}
                       (tr [:code-enforcement/open-case-creation])))]])
               (when (:complaint/complainer-email complaint)
                 [:span
                  (cc/button
                    {:size       :small
                     :class-name (if can-create-case? "ml-4" "")
                     :kind       :tertiary
                     :href       (complaint-reply-link tr (:complaint/complainer-name complaint) (:complaint/complainer-email complaint) complaint-address)}
                    (tr [:complaint/send-reply]))])
               (when (and allow-edit? edit-permission? (not reopen?))
                 [:span.float-right
                  (cc/button
                    {:size       :small
                     :kind       :tertiary
                     :class-name "ml-4"
                     :on-click   (fn [_] (if edit?
                                           (>evt [::complaint-subs/close-edit])
                                           (>evt [::complaint-subs/start-edit
                                                  (-> (select-keys complaint complaint-model/complaint-edit-keys)
                                                      (update :complaint/category-group-config :db/id)
                                                      (p/update-if-contains :complaint/external-source :db/id))])))}
                    (tr [(if edit? :close :edit)]))])])])))]))
